<<!--  -->
<template>
  <div>
    <div class="list">
      <div class="w-120">
        <span>京东联盟ID:</span>
        <span class="c-ea4">*</span>
      </div>
      <el-input  class="w-278 kucun" v-model.trim="jd_union_id"></el-input>
    </div>
    <div class="list">
      <div class="w-120">推广位ID:</div>
      <el-input  class="w-278" v-model.trim="jd_promote_id"></el-input>
    </div>
    <el-button type="primary" class="baocun" @click="setJDPid">点击保存</el-button>
  </div>
</template>

<script>
export default {
  name: "myjdpid",
  data() {
    return {
      jd_union_id: "",
      jd_promote_id: "",
      api: {
        setJDPid: "/home/setJDPid",
        getUserInfo: "/home/getUserInfo"
      }
    };
  },
  components: {},
  created() {
    this.getUserInfo();
  },
  mounted() {},
  methods: {
    setJDPid() {
      let _this = this;
      let reg=new RegExp("^[0-9]*$");
      if (!this.jd_union_id) {
        this.$message({
          message: "京东联盟id不能为空",
          type: "warning"
        });
        return false;
      }else if(!reg.test(this.jd_union_id)){
        this.$message({
          message: "京东联盟id填写数字",
          type: "warning"
        });
        return false;
      }else if(this.jd_promote_id&&!reg.test(this.jd_promote_id)){
        this.$message({
          message: "推广位id填写数字",
          type: "warning"
        });
        return false;
      }
      let data = {
        jd_union_id: this.jd_union_id,
        jd_promote_id: this.jd_promote_id
      };
      this.$http({
        method: "GET",
        params: data,
        url: this.api.setJDPid
      }).then(res => {
        if (res.code == 1) {
          this.$message({
            message: "京东联盟PID设置成功",
            type: "success"
          });
          _this.getUserInfo();
        } else {
          this.$message({
            message: res.data,
            type: "warning"
          });
        }
      });
    },
    getUserInfo() {
      let _this = this;
      this.$http({
        method: "GET",
        url: _this.api.getUserInfo
      })
        .then(res => {
          if (res.code == 1) {
            _this.jd_union_id = res.data.jd_union_id;
            _this.jd_promote_id = res.data.jd_promote_id;
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style  scoped>
.w-278 {
  width: 278px;
}
.w-120 {
  width: 110px;
  line-height: 32px;
  display: flex;
  align-items: center;
  text-align: right;
  color: #606266;
  font-size: 14px;
  flex-direction: row-reverse;
  padding-right: 12px;
}
.c-ea4 {
  color: #ea4c51;
}
.list {
  display: flex;
  align-items: center;
  height: 32px;
  margin-top: 20px;
}
.baocun {
  margin: 20px 0 0 120px;
}
</style>